import "./AuthCard.css";
import React, { Dispatch, SetStateAction } from "react";
import { authCardData } from "../../data/data";
import { useNavigate } from "react-router-dom";
import { UserData } from "../../routes/AppRoutes";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store";
import { setFeatureName } from "../../redux/AuthCardReducer/AuthCardSlice";
import Header from "../../layouts/header/Header";
import { reactIcons } from "../../icons/reactIcons";

export interface cardProps {
  isAuthenticated: UserData | null;
  setIsAuthenticated: Dispatch<SetStateAction<UserData | null>>;
}

type userRole = {
  id: number;
  displayName: string;
  route: string;
  roles: string;
};

const AuthCard: React.FC<cardProps> = ({
  isAuthenticated,
  setIsAuthenticated,
}) => {
  const dispatcher = useDispatch();
  const { token_details } = useSelector((state: RootState) => state?.Auth);
  console.log("token_details:", token_details);
  const navigate = useNavigate();

  const handleRouteModule = (routeModule: userRole) => {
    dispatcher(setFeatureName(routeModule?.roles));
    localStorage.setItem("oc_all_in_FeatureName", routeModule?.roles);
    navigate(routeModule?.route);
  };

  return (
    <div className="authcard">
      <Header setIsAuthenticated={setIsAuthenticated} />
      <div className="authcard-container">
        <h3 className="authCard-info-text">
          System identified, this User has the access to the following modules,
          select any to proceed.
        </h3>
        <div className="card-wrapper">
          {authCardData?.map((item: any, i: number) => {
            return token_details?.featureAccess.length === 0 ? (
              <div
                className="card-content"
                key={i}
                onClick={() => handleRouteModule(item)}
              >
                <h3 className="card-title">{item?.displayName}</h3>
                <span>
                  <reactIcons.rightArrow />
                </span>
              </div>
            ) : token_details?.featureAccess.includes(item?.roles) ? (
              <div
                className="card-content"
                key={i}
                onClick={() => handleRouteModule(item)}
              >
                <h3 className="card-title">{item?.displayName}</h3>
                <span>
                  <reactIcons.rightArrow />
                </span>
              </div>
            ) : (
              ""
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default AuthCard;
